<template>
  <div class="m-head">
    <i class="icon icon-arrow-left" @click="goBack"></i>
    <span class="m-tit">{{title}}</span>

    <div class="m-more">
      <slot></slot>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  props: {
    title: {
      type: String,
      default: '51体检专家'
    },
    to: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  methods: {
    goBack () {
      // this.$router.go(-1);
      window.history.back()
      this.$router.isBack = true
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
//@import "../../assets/css/mixin";
.m-head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  line-height: 44px;
  background-color: #f5f5f5;
  color: #434343;
  z-index: 100;
  .icon-arrow-left {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 15px;
    z-index: 5;
    font-size: 20px;
  }
  .m-tit {
    position: absolute;
    left: 70px;
    right: 70px;
    z-index: 5;
    line-height: 44px;
    font-size: 20px;
    text-align: center;
    overflow: hidden;
    word-wrap: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .m-more {
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }
}
</style>
